import { MdCheck } from 'react-icons/md'

import Button from 'shared/components/Button'
import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const Title = styled.span`
  color: ${colors.green};
  font-weight: 700;
  font-size: 16px;
`
export const StyleButton = styled(Button)`
  margin-right: 15px;
`
export const StyledCheck = styled(MdCheck)`
  color: ${colors.blue};
  font-size: 80px !important;
  padding: 10px 10px 10px 10px;
  border: 3px solid ${colors.blue};
  border-radius: 50%;
`
